<ic-auth-wrapper>
	<div class="login-options" data-test="login-options-window">
		@if (error$ | async) {
			<p class="message error"><i class="fa fa-exclamation-triangle"></i> {{ error$ | async | translate }}</p>
		}
		@if (inactivity()) {
			<p class="message inactive">{{ "auth.errors.timed_out" | translate }}</p>
		}
		<div class="button" data-test="button-login-with-organisation">
			<ui-button [disabled]="loading$ | async" [loading]="loading$ | async" (click)="login()"
				>{{ "auth.signin_with" | translate }} {{ hqName$ | async }}</ui-button
			>
		</div>
		<div class="divider">{{ "general.or" | translate | uppercase }}</div>
		<div class="local-login" data-test="button-login-with-username">
			<a class="ic-btn ic-center" (click)="localLogin()">{{ "auth.signin_with_username" | translate }}</a>
		</div>
		<div class="select-organisation">
			<a class="ic-btn ic-center" (click)="selectOrganisation()">{{ "general.change_organisation" | translate }}</a>
		</div>
	</div>
</ic-auth-wrapper>
